<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { ref } from "vue";
import { useMainStore } from "../store";
import type { QuizData } from '../types';
import { useLeadSubmit } from '../composables/useLeadSubmit';
import { useGateAnalytics } from '../composables/useGateAnalytics';

// Legacy gate view. The money path (lead assembly, POST, cookies, analytics,
// redirect) lives in useLeadSubmit — shared with the flow engine's gate block
// (DEV-1135). This component only owns the legacy markup and form state.
const store = useMainStore();
const quizData = store.quizData as QuizData;
const gate = store.gateData || {};
const form = ref(store.formLead);

useGateAnalytics(quizData, form);
const { submit, skip } = useLeadSubmit(quizData, form);

const handleSubmit = () => submit();
const handleSkip = () => skip();
</script>

<template>
  <div class="step step-5 step-form active">
    <h4>{{ gate.title || '' }}</h4>
    <h6 v-if="gate.sub_title">{{ gate.sub_title }}</h6>
    <div class="text-center" v-if="gate.image">
      <img :src="gate.image" :alt="gate.title" />
    </div>
    <p v-if="gate.description">{{ gate.description }}</p>
    <form @submit.prevent="handleSubmit" class="needs-validation novalidate">
      <input
        type="text"
        name="name"
        :placeholder="gate.namePlaceholder"
        :aria-label="gate.namePlaceholder"
        required
        v-model="form.name"
        :title="gate.nameError"
        minlength="3"
      >
      <input
        v-if="gate.usePhone"
        type="tel"
        name="phone"
        placeholder="Digite seu telefone"
        aria-label="Digite seu telefone"
        required
        v-model="form.phone"
      >
      <input
        v-if="gate.useEmail"
        type="email"
        name="email"
        :placeholder="gate.emailPlaceholder"
        :aria-label="gate.emailPlaceholder"
        required
        v-model="form.email"
        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
        :title="gate.emailError"
      >
      <button type="submit" :disabled="store.fetching" class="cta-button">
        <span v-if="!store.fetching">{{ gate.cta }}</span>
        <span v-else class="loading-content">
          {{ gate.loading }} <font-awesome-icon icon="fas fa-spinner" class="loading-icon" spin />
        </span>
      </button>
      <button
        v-if="quizData.skip && quizData.skip_cta"
        type="button"
        @click="handleSkip"
        :disabled="store.fetching"
        class="skip-button"
      >
        {{ quizData.skip_cta }}
      </button>
    </form>
  </div>
</template>
